import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const CardContent = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  justifyContent: 'center',
  alignItems: 'start',

  [theme.breakpoints.up('lg')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(10)}`,
  },

  '& > *': {
    width: '100%',
  },
}));

export const InputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const OptInButton = styled(Button)(({ theme }) => ({
  height: 'fit-content',

  [theme.breakpoints.up('sm')]: {
    width: 'fit-content',
  },
}));

export const Link = styled(Text)(({ theme }) => ({
  color: theme.palette.text.blue,
  cursor: 'pointer',
  textDecoration: 'underline',
}));
